export default {
  auto: 'Automática',
  transparent: 'Transparente',

  white: 'Branco',
  iceBlue: 'Azul Gelo',
  iceCyan: 'Ciano Gelo',
  iceGreen: 'Verde Gelo',
  solarIvory: 'Marfim Solar',
  peachCream: 'Creme Pêssego',
  mistRose: 'Rosa Névoa',
  iceLavender: 'Lavanda Gelo',

  mist: 'Névoa',
  mistBlue: 'Azul Névoa',
  mistCyan: 'Ciano Névoa',
  mistGreen: 'Verde Névoa',
  vanillaYellow: 'Amarelo Baunilha',
  lightPeach: 'Pêssego Claro',
  lightRose: 'Rosa Claro',
  richLavender: 'Lavanda Rica',

  concrete: 'Concreto',
  vividBlue: 'Azul Vivo',
  electricCyan: 'Ciano Elétrico',
  mintGreen: 'Verde Menta',
  vividYellow: 'Amarelo Vivo',
  brightYellowOrange: 'Laranja Amarelado Brilhante',
  salmonPink: 'Rosa Salmão',
  hotPink: 'Rosa Choque',

  steel: 'Aço',
  dodgerBlue: 'Azul Dodger',
  brightCyan: 'Ciano Brilhante',
  limeGreen: 'Verde Lima',
  saffronYellow: 'Amarelo Açafrão',
  amber: 'Âmbar',
  vibrantRed: 'Vermelho Vibrante',
  violet: 'Violeta',

  lead: 'Chumbo',
  nuclearBlue: 'Azul Nuclear',
  oceanCyan: 'Ciano Oceano',
  mallowGreen: 'Verde Malva',
  goldYellow: 'Amarelo Ouro',
  brightOrange: 'Laranja Brilhante',
  strongRed: 'Vermelho Forte',
  lightPurple: 'Roxo Claro',

  graphite: 'Grafite',
  sapphireBlue: 'Azul Safira',
  deepCyan: 'Ciano Profundo',
  seaGreen: 'Verde Mar',
  goldenrod: 'Goldenrod',
  intenseOrange: 'Laranja Intenso',
  rubyRed: 'Vermelho Rubi',
  mediumPurple: 'Roxo Médio',

  black: 'Preto',
  deepBlue: 'Azul Profundo',
  darkPetroleum: 'Petróleo Escuro',
  forestGreen: 'Verde Floresta',
  burntMustard: 'Mostarda Queimada',
  safetyOrange: 'Laranja Segurança',
  darkWine: 'Vinho Escuro',
  darkPurple: 'Roxo Escuro',
};
